<template>
   

    <span v-if="props?.status === 'paid'" class="badges badges-bg badges-paid">
        Paiement encaissé
    </span>

    <span v-else-if="props?.status === 'scheduled'" class="badges badges-bg badges-unpaid"
        title="👉 Paiement programmé signifie que ce paiement est prévu mais n’a pas encore été effectué.">
        Paiement programmé
    </span>


</template>
<script setup>
import { defineProps } from 'vue';
import i18n from '@/i18n/index'
const props = defineProps({
    status: {
        type: [String],
        default: null,
    },
});
</script>